<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="row vertical-align mt-3 ms-1 me-1">
          <div class="col-sm-6">
                <h3>Transaksjoner</h3>
                <div v-if="!loading" class="mt-5">
                    <SelectDate ref="selectDateFrom" label="Velg fra og med dato" :selectedDate="fromDateString"/>
                    <SelectDate ref="selectDateTo" label="Velg til og med dato" :selectedDate="toDateString"/>
                    <button type="button" class="bo_btn" @click="showTransactionsReport"> Vis transaksjoner</button>

                    <div v-if="transactionsReport != undefined">
                      <ShowTransactionsReport :fromDate="fromDate" :toDate="toDate" :transactionsReport="transactionsReport" :company="company"/>
                    </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import ShowTransactionsReport from "@/components/report/transactions/ShowTransactionsReport";
  import ReportService from "@/services/report/ReportService";
  import SelectDate from "@/components/other/SelectDate.vue";
  import moment from "moment";

  export default {
    components: {SelectDate, LoadingSpinner, ShowTransactionsReport},
    data() {
      return {
        loading: true,

        merchant: '',
        company: {},
        fromDate: new Date(),
        toDate: new Date(),
        fromDateString: moment().format('YYYY-MM-DD'),
        toDateString: moment().format('YYYY-MM-DD'),
        transactionsReport: undefined
      };
    },
    mounted() {
      ReportService.getDataForReportGui().then(
          (response) => {
            let dataForGui = response.data;
            //console.log("dataForGui: " +  JSON.stringify(dataForGui));
            this.locations = dataForGui.locations;
            this.company = dataForGui.company;
            this.vat = dataForGui.vat;
            this.merchant = dataForGui.merchant;

            this.locationId = this.locations.length ? this.locations[0].id : '';
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      showTransactionsReport() {
        this.loading = true;
        this.fromDateString = this.$refs.selectDateFrom.getSelectedDate();
        this.toDateString = this.$refs.selectDateTo.getSelectedDate();
        this.fromDate = moment(this.fromDateString, 'YYYY-MM-DD').toDate();
        this.toDate = moment(this.toDateString, 'YYYY-MM-DD').toDate();

        ReportService.getTransactionsReport(this.fromDateString, this.toDateString).then(
            (response) => {
              this.transactionsReport= response.data;
              //console.log('xReportCounters: ' +  JSON.stringify(this.xReportCounters));
              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      }
    }
  };
</script>
